import React, { FC, ReactNode } from 'react';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons/faCircleCheck';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import styles from './subscribeFeaturesTableStyles.scss';

type Plan = 'Lite' | 'Premium' | 'Elite';

const plans: Plan[] = ['Lite', 'Premium', 'Elite'];

const rows: {
  label: ReactNode;
  byPlan: Record<Plan, ReactNode>;
}[] = [
  {
    label: 'Access to Stock Reports Written By Hedge Fund Managers',
    byPlan: {
      Lite: (
        <>
          5 credits <br /> Choose your own ideas
        </>
      ),
      Premium: (
        <>
          35 credits <br /> Choose your own ideas
        </>
      ),
      Elite: (
        <>
          Entire research database <br />
          (~15k ideas)
        </>
      )
    }
  },
  {
    label: 'Access Annual Top Stocks Report',
    byPlan: {
      Lite: false,
      Premium: '(Winners & Runner Ups)',
      Elite: true
    }
  },
  {
    label: "Access to Portfolio Manager's Commentary on Investments Reports",
    byPlan: {
      Lite: 'Limited',
      Premium: 'Limited',
      Elite: true
    }
  },
  {
    label: 'Access to All of Short Ideas',
    byPlan: { Lite: false, Premium: false, Elite: true }
  },
  {
    label: "Invites to 'Fireside Chats'",
    byPlan: { Lite: false, Premium: true, Elite: true }
  },
  {
    label: 'Direct Access to All of Contest Submissions',
    byPlan: { Lite: true, Premium: true, Elite: true }
  },
  {
    label: 'Filter for Investment Ideas By Top Ranked Members',
    byPlan: { Lite: 'Limited', Premium: 'Limited', Elite: true }
  },
  {
    label: 'Screen for Top Rated Ideas',
    byPlan: { Lite: 'Limited', Premium: 'Limited', Elite: true }
  },
  {
    label: 'Customize and Monitor Research Contributed on Your Portfolio',
    byPlan: { Lite: 'Limited', Premium: 'Limited', Elite: true }
  },
  {
    label: 'Access to Consensus Tool',
    byPlan: { Lite: true, Premium: true, Elite: true }
  },
  {
    label: 'Follow Top Ranked Members and Track Their New Ideas',
    byPlan: { Lite: 'Limited', Premium: 'Limited', Elite: true }
  },
  {
    label: 'Weekly Round Up of Trending and Most Viewed Ideas',
    byPlan: { Lite: false, Premium: false, Elite: true }
  },
  {
    label: 'Emails Detailing Activity Around Names in Your Portfolio',
    byPlan: { Lite: 'Monthly', Premium: 'Monthly', Elite: 'Weekly' }
  },
  {
    label: 'Emails Highlighting Unique Investment Opportunities Across SumZero',
    byPlan: { Lite: false, Premium: 'Monthly', Elite: 'Weekly' }
  },
  {
    label: 'Receive Special Reports',
    byPlan: { Lite: false, Premium: false, Elite: true }
  },
  {
    label: 'Dedicated Rep',
    byPlan: { Lite: false, Premium: false, Elite: true }
  }
];

const renderCell = (cell: ReactNode): ReactNode => {
  if (cell === true) return <FontAwesomeIcon data-color="green" icon={faCircleCheck} />;
  if (cell === false) return <FontAwesomeIcon data-color="gray" icon={faCircleXmark} />;
  return cell;
};

const SubscribeFeaturesTable: FC = () => (
  <div className={classNames(styles.subscribeFeaturesTableContainer, 'table-responsive')}>
    <table className="table table-striped text-center">
      <thead>
        <tr>
          <th />
          {plans.map(plan => (
            <th key={plan} className="text-center">
              <h4>
                <strong>{plan}</strong>
              </h4>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map(row => (
          <tr key={String(row.label)}>
            <td>{row.label}</td>
            {plans.map(plan => (
              <td key={`${row.label}-${plan}`}>{renderCell(row['byPlan'][plan])}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default SubscribeFeaturesTable;
